import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { RibbonV2ThetaVaultFactory } from "../codegen/RibbonV2ThetaVaultFactory";
import { VaultAddressMap } from "../constants/constants";
import { useWeb3Context } from "./web3Context";
export var getV2Vault = function (library, vaultOption, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    if (!VaultAddressMap[vaultOption].v2) {
        return null;
    }
    var provider = useSigner ? library.getSigner() : library;
    var vault = RibbonV2ThetaVaultFactory.connect(VaultAddressMap[vaultOption].v2, provider);
    return vault;
};
var useV2Vault = function (vaultOption) {
    var _a = useWeb3React(), active = _a.active, library = _a.library;
    var provider = useWeb3Context().provider;
    var _b = useState(null), vault = _b[0], setVault = _b[1];
    useEffect(function () {
        if (active && library) {
            var vault_1 = getV2Vault(library || provider, vaultOption, active);
            setVault(vault_1);
        }
    }, [active, library, provider, vaultOption]);
    return vault;
};
export default useV2Vault;
//# sourceMappingURL=useV2Vault.js.map